import { Box, Paper, Stack, Typography } from "@mui/material";
import React from "react";

export const GrapefruitInteractionSection = () => {
  return (
    <Paper
      elevation={0}
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: "31px 20px 34px",
        borderRadius: "20px",
        border: "1.5px solid",
        borderColor: "primary.main",
        boxShadow: "-8px 8px 0px #b7b9d0",
        position: "relative",
        maxWidth: "90%",
        margin: "32px auto"
      }}
    >
      {/* Sun Protection Section */}
      <Stack
        direction={{ xs: "column-reverse", sm: "row" }} 
        spacing={{ xs: 2.5, sm: 5.5 }}
        alignItems="center"
        justifyContent="center"
        width="100%"
        sx={{ mb: 4 }}
      >
        <Typography
          variant="body1"
          color="primary.main"
          sx={{ maxWidth: "507px", textAlign: "left" }}
        >
          <Box component="span" fontWeight="900">
            You should limit time in the sun during treatment with IBTROZI.
          </Box>
          <br />
          IBTROZI may make your skin sensitive to sunlight. Wear a hat and clothes that 
          cover your skin and use sunscreen with sun protective factor (SPF) if you are 
          in the sun during treatment with IBTROZI and for at least 5 days after your 
          last dose of IBTROZI.
        </Typography>
        <Box
          component="img"
          src="/images/taking-ibtrozi/sun-protection-icon.svg"
          alt=""
          sx={{ width: "130px", height: "130px" }}
        />
      </Stack>

      {/* Divider Line */}
      <Box
        sx={{
          width: "100%",
          height: "1px",
          backgroundColor: "primary.main",
          mb: 4
        }}
      />

      {/* Grapefruit Interaction Section */}
      <Stack
        direction={{ xs: "column-reverse", sm: "row" }} 
        spacing={{ xs: 2.5, sm: 5.5 }}
        alignItems="center"
        justifyContent="center"
        width="100%"
      >
        <Typography
          variant="body1"
          color="primary.main"
          sx={{ maxWidth: "507px", textAlign: "left" }}
        >
          <Box component="span" fontWeight="900">
            You should avoid grapefruit, grapefruit juice, or products that 
            contain grapefruit during your treatment with IBTROZI.
          </Box>
          <br />
          Grapefruit may increase the amount of IBTROZI in your blood, which 
          may increase the risk of IBTROZI side effects.
        </Typography>
        <Box
          component="img"
          src="/images/taking-ibtrozi/no-citrus-icon-desktop.svg"
          alt=""
          sx={{ width: "130px", height: "130px" }}
        />
      </Stack>
    </Paper>
  );
};